import type { NetworkEnum } from '@/graphql/generatedTypesAndHooks';
import { Token } from '@/models';
import type { TokenId } from '@hashgraph/sdk';

export abstract class AbstractTokenService {
  abstract chains: NetworkEnum[];

  abstract getTokenInfo(tokenId: string | TokenId, network: NetworkEnum, contractId?: string): Promise<Token | null>;
}
